// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8Tuu6","content":"styles_content__8jFdZ","tableWrap":"styles_tableWrap__w5KBs"};